import React from 'react';
import { Button } from 'react-bootstrap';
import {
  computeAnnualSavingsLabel,
  formatEnvelopeLabel,
  formatPriceParts,
  getPlanVariant,
  normalizeBillingInterval,
} from '../../utils/plansCatalog';

const PlanPricingCard = ({
  group,
  billingInterval,
  isCurrent,
  onSelect,
  disabled,
}) => {
  const interval = normalizeBillingInterval(billingInterval);
  const plan = getPlanVariant(group, interval);
  const priceParts = formatPriceParts(plan, interval);
  const savings =
    interval === 'year' ? computeAnnualSavingsLabel(group) : null;
  const showRecommended = group.isRecommended;
  const isFree = priceParts.isFree;
  const isContact = priceParts.isContact;

  if (!plan) return null;

  return (
    <div
      className={[
        'plan-pricing-card',
        showRecommended ? 'plan-pricing-card--featured' : '',
        isCurrent ? 'plan-pricing-card--current' : '',
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {showRecommended && (
        <span className="plan-pricing-card__badge">Popular</span>
      )}
      {isCurrent && (
        <span className="plan-pricing-card__badge plan-pricing-card__badge--current">
          Current plan
        </span>
      )}

      <h3 className="plan-pricing-card__title">{group.name || plan.name}</h3>
      <p className="plan-pricing-card__subtitle">
        {group.tagline || group.description || plan.tagline || ''}
      </p>

      <div className="plan-pricing-card__price">
        <span className="plan-pricing-card__price-value">
          {priceParts.display}
        </span>
        {!isFree && (
          <span className="plan-pricing-card__price-suffix">{priceParts.suffix}</span>
        )}
        {isFree && (
          <span className="plan-pricing-card__price-suffix">{priceParts.suffix}</span>
        )}
      </div>

      {savings && (
        <p className="plan-pricing-card__savings">{savings}</p>
      )}

      <p className="plan-pricing-card__allowance">
        <strong>{formatEnvelopeLabel(group)}</strong>
      </p>

      {group.features?.length > 0 && (
        <ul className="plan-pricing-card__features">
          {group.features.map((feature, idx) => (
            <li key={idx}>
              <i className="ri-check-line" aria-hidden />
              {typeof feature === 'string' ? feature : feature?.name ?? String(feature)}
            </li>
          ))}
        </ul>
      )}

      <Button
        variant={showRecommended ? 'primary' : 'outline-primary'}
        className="plan-pricing-card__cta w-100"
        disabled={disabled || isCurrent || !plan}
        onClick={() => onSelect(group, interval, plan)}
      >
        {isCurrent
          ? 'Current plan'
          : isContact
            ? 'Contact teams'
            : isFree
              ? 'Start free'
              : 'Get started'}
      </Button>
    </div>
  );
};

export default PlanPricingCard;
